<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!isPostRoute"></app-footer>

